// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qmjv","footer":"styles_footer__3nn1L","passCodeTooltip":"styles_passCodeTooltip__18zhr"};